import { render } from "./JudgeAffiliation.vue?vue&type=template&id=87904c5a"
import script from "./JudgeAffiliation.vue?vue&type=script&lang=js"
export * from "./JudgeAffiliation.vue?vue&type=script&lang=js"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__